export const saveCommission = (vals) => (dispatch, getState, { api }) => {
    return api.put('/private/commission/edit', vals)
};
